import { path } from 'ramda';
import { IS_BIZ_USER } from 'reactApp/appHelpers/configHelpers';
import { renderUnpublishWeblinkDialog } from 'reactApp/components/SharingNewBiz/Weblink/SharingNewWeblink.helpers';
import { deleteAllUsers } from 'reactApp/modules/folderAccessControlList/folderAccessControlList.actions';
import type { PublishItem } from 'reactApp/modules/modifying/modifying.types';
import { store as reduxStore } from 'reactApp/store';

import { unPublishHelper } from '../publishHelper';
import { getSelectedItems } from './helpers/getSelectedItems';

export const unPublish = (): void => {
    const state = reduxStore.getState();
    const selectedItems = IS_BIZ_USER
        ? (getSelectedItems(state) as PublishItem[])
        : (getSelectedItems(state).filter((item) => path(['weblink'], item)) as PublishItem[]);

    if (!selectedItems.length) {
        return;
    }

    const onActionClick = () => {
        unPublishHelper({ items: selectedItems });
    };

    if (IS_BIZ_USER) {
        const onActionBizClick = () => {
            onActionClick();
            selectedItems
                .filter((item) => item.isFolder)
                .forEach((item) => {
                    reduxStore.dispatch(deleteAllUsers({ item }));
                });
        };
        renderUnpublishWeblinkDialog({ onActionClick: onActionBizClick });
        return;
    }

    onActionClick();
};
